import { TFunction } from 'i18next';
import { ErrorKey } from '../types/enums';

export const getErrorMessage = (t: TFunction, key?: ErrorKey) => {
  const unknownError = t('signup:unknownError', 'Unknown error, please try again later.');

  switch (key) {
    case ErrorKey.SIGNUP_EMAIL_ALREADY_EXIST: {
      return (
        {
          [ErrorKey.SIGNUP_EMAIL_ALREADY_EXIST]: t('signup:validation.emailAlreadyExists', 'Email already exists.')
        }[key] || unknownError
      );
    }
    case ErrorKey.SIGNUP_COMPANY_ALREADY_EXIST: {
      return (
        {
          [ErrorKey.SIGNUP_COMPANY_ALREADY_EXIST]: t(
            'signup:validation.companyExists',
            'Company already exists, please contact support'
          )
        }[key] || unknownError
      );
    }
    default:
      return unknownError;
  }
};
